const VSwitch = ({ value }, { slots, attrs }) => {
  const slotFn = value in slots ? slots[value] : slots.default
  return slotFn ? slotFn(attrs) : null
}

VSwitch.props = ['value']

export default VSwitch
